import { testimonials } from '../../data/parasHomeData';
import { StarIcon } from './HomeIcons';

export default function TestimonialsSection() {
  return (
    <section className="section" id="testimonials" aria-label="Customer testimonials">
      <div className="section-inner">
        <div className="section-head center">
          <span className="section-label">Customer Reviews</span>
          <h2 className="section-title">What Our Customers Say</h2>
          <p className="section-desc">Farmers and gardeners across India trust Paras Organics for consistent, natural results.</p>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((t, i) => (
            <article key={i} className="testi-card" itemScope itemType="https://schema.org/Review">
              <div className="testi-stars" aria-label={`${t.rating} out of 5 stars`}>
                {[0, 1, 2, 3, 4].map((star) => (
                  <StarIcon key={star} className="ui-icon review-star-icon" filled={star < t.rating} />
                ))}
              </div>
              <p className="testi-text" itemProp="reviewBody">"{t.text}"</p>
              <div className="testi-author">
                <div className="testi-avatar" aria-hidden="true">{t.name[0]}</div>
                <div>
                  <div className="testi-name" itemProp="author">{t.name}</div>
                  <div className="testi-location">{t.location}</div>
                </div>
                <div className="testi-product-tag">{t.product}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
